// extracted by mini-css-extract-plugin
export default {"userBox":"tags_userBox__0ixi2","paramsBox":"tags_paramsBox__HflFX","btnBox":"tags_btnBox__2Lu54"};